import { render, staticRenderFns } from "./PatentTranslateForm.vue?vue&type=template&id=58b74174&"
import script from "./PatentTranslateForm.vue?vue&type=script&lang=js&"
export * from "./PatentTranslateForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentTranslateForm.vue?vue&type=style&index=0&id=58b74174&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports